
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 215.461 215.461","enable-background":"new 0 0 215.461 215.461"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M207.961,0.004H7.5c-4.142,0-7.5,3.357-7.5,7.5v200.453c0,4.142,3.358,7.5,7.5,7.5h122.262c4.143,0,7.5-3.358,7.5-7.5\tc0-4.143-3.357-7.5-7.5-7.5H15v-80.025h51.932v36.918c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5V69.488\tc0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v35.943H15V15.004h107.262V64.24c0,4.142,3.357,7.5,7.5,7.5h44.385\tc4.143,0,7.5-3.358,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-36.885V15.004h63.199v123.678h-70.699c-4.143,0-7.5,3.357-7.5,7.5\tc0,4.143,3.357,7.5,7.5,7.5h70.699v46.775h-26.314c-4.143,0-7.5,3.357-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h33.814\tc4.143,0,7.5-3.358,7.5-7.5V7.504C215.461,3.361,212.104,0.004,207.961,0.004z"}})])
          )
        }
      }
    